import { ref, type Ref } from 'vue'

// 定义一个类型别名，表示事件的类型
type EventCallback = (...args: any[]) => void

// 定义事件对象类型
interface EventObject {
  id: string | number
  event: EventCallback
}

// const events: Ref<EventObject[]> = ref([]);

// 定义 EventBus 接口
interface EventBus {
  events: Ref<EventObject[]>
  addEvent(id: string | number, event: EventCallback): void
  removeEvent(id: string | number): void
  hasEvent(id: string | number): boolean
  trigger(id?: string | number, ...args: any[]): void
}

export const eventBus: EventBus = {
  events: ref([]),
  // 添加事件到事件列表
  addEvent(id: string | number, event: EventCallback): void {
    // 检查是否已经存在相同 id 的事件，如果存在则覆盖
    const exists = this.events.value.some(eventObject => eventObject.id === id)
    if (exists) {
      this.events.value = this.events.value.map(eventObject => {
        if (eventObject.id === id) {
          return { id, event }
        }
        return eventObject
      })
    } else {
      this.events.value.push({ id, event })
    }
  },
  // 移除指定 id 的事件
  removeEvent(id: string | number): void {
    this.events.value = this.events.value.filter(eventObject => eventObject.id !== id)
  },
  // 检查是否存在指定 id 的事件
  hasEvent(id: string | number): boolean {
    return this.events.value.some(eventObject => eventObject.id === id)
  },
  // 触发指定 id 的事件，如果 id 不存在则触发所有事件
  trigger(id?: string | number, ...args: any[]): void {
    if (id === undefined) {
      // 触发所有事件
      this.events.value.forEach(({ event }) => {
        event && event(...(args as []))
      })
    } else {
      // 触发特定 id 的事件
      this.events.value
        .filter(eventObject => eventObject.id === id)
        .forEach(({ event }) => {
          event && event(...(args as []))
        })
    }
  }
}
